/**
 * 自定义枚举
 */
export enum GtagAction {
  /** 点击接受邀请按钮 */
  FriendsInviteAccept = 'friends—invite_click',
  /** 点击加入房间 */
  RoomInviteJoin = 'room-join_click',
  /** 下载APP */
  DownloadApp = 'download-app',
  /** 拉起APP */
  LaunchApp = 'launch-app',
  /** 复制至剪切板 */
  CopyToClipboard = 'copy-to_clipboard'
}

export enum EventCategory {
  /** 好友邀请页 */
  ActivityRafflePage = 'activity-raffle_page',
  /** 好友邀请页 */
  FriendsLandingPage = 'invite-friends_page',
  /** 房间邀请页 */
  RoomInviteLandingPage = 'invite-room_page',
  /** 个人名片页 */
  UserProFileLandingPage = 'user-profile_page',
  /** 礼物排行榜 */
  GiftRankingLandingPage = 'gift-ranking',
  GiftRankingLandingMePage = 'gift-ranking-me',
  /** 问卷反馈 */
  FeedbackLandingPage = 'feedback',
  /** 免费歌曲版权协议 */
  MusicLicensingPage = 'music-licensing',
  TopUpPage = 'top-up',
  BoardPage = 'board',
  Ranking = 'ranking',
  Activity = 'activity',
  Task = 'task',
  /** 测速页 */
  SpeedTestLandingPage = 'speed-test',
  /* 账号反馈 */
  AccountFeedbackPage = 'account-feedback',
  RobotChatPage = 'robot-chat'
}

/**
 * 按钮页面元素来源
 */
export enum PageButtonSourceFrom {
  /** 调起失败引导弹窗下载按钮 */
  LeadToDownload = 'leadTo-download',
  /** 房间邀请头部下载 */
  RoomTopDownload = 'room-top_download',
  /** 房间邀请底部加入房间 */
  RoomFooterJoin = 'room-footer_join',
  /** 房间邀请弹窗加入房间 */
  RoomPopupJoin = 'room-popup_join',
  /** 好友接受邀请 */
  FriendsAcceptBtn = 'friends-accept_btn',
  /** 个人名片打开APP按钮 */
  UserProfileBtn = 'user-profile_btn',
  /** 错误数据页打开APP按钮 */
  ErrorOpenApp = 'error-open_app'
}

/** 触发方式 */
export enum TriggerMode {
  /** 程序触发/被动触发 */
  PassiveTrigger = 0,
  /** 用户主动触发 **/
  ActiveTrigger = 1
}
